import {
	Dialog,
	DialogContent,
	DialogTitle,
	LinearProgress,
	TextField,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { generateErrorState, handleValidateObj, isEditorEmpty, sanitizedConfig } from "helpers/utils";
import React, { useState } from "react";
import AddDialogStyle from "styles/application/AddDialogStyle";
import * as yup from "yup";
import TextEditor from 'components/Elements/TextEditor';
import sanitizeHtml from "sanitize-html";


const schema = yup.object({
	note: yup
		.string("This field must be a string")
		.required("This field is required"),
});

const ADD = AddDialogStyle();
const defaultData = { note: "" };
const defaultError = { note: null };

const useStyles = makeStyles()((theme) => ({
	dialogContent: {
		display: "flex",
		flexDirection: "column",
	},
	createButton: {
		width: "auto",
	},
}));

const AddNoteDialog = ({ open, handleClose, createHandler }) => {
	const { classes, cx } = useStyles();
	const [input, setInput] = useState(defaultData);
	const [errors, setErrors] = useState(defaultError);
	const [isUpdating, setIsUpdating] = useState(false);

	const closeOverride = () => {
		setInput(defaultData);
		setErrors(defaultError);

		handleClose();
	};

	const handleCreateProcess = async () => {
		setIsUpdating(true);

		try {
			// Sanitize the HTML before validation and saving
			const sanitizedNote = sanitizeHtml(input.note, sanitizedConfig);

			const localChecker = await handleValidateObj(schema, { note: sanitizedNote });
			
			if (!localChecker.some((el) => el.valid === false)) {
				await createHandler(sanitizedNote);

				closeOverride();
			} else {
				const newErrors = generateErrorState(localChecker);
				setErrors({ ...errors, ...newErrors });
			}

			setIsUpdating(false);
		} catch (err) {
			setIsUpdating(false);
			closeOverride();
		}
	};

	const handleEnterPress = (e) => {
		// 13 is the enter keycode
		if (!isUpdating) {
			if (e.keyCode === 13) {
				handleCreateProcess();
			}
		}
	};

	return (
		<Dialog
			open={open}
			onClose={closeOverride}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			{isUpdating ? <LinearProgress /> : null}
			<ADD.ActionContainer>
				<DialogTitle id="alert-dialog-title">
					{<ADD.HeaderText>Add Note</ADD.HeaderText>}
				</DialogTitle>
				<ADD.ButtonContainer>
					<ADD.CancelButton
						onClick={closeOverride}
						variant="contained"
						style={{ width: "auto" }}
					>
						Cancel
					</ADD.CancelButton>
					<ADD.ConfirmButton
						onClick={handleCreateProcess}
						variant="contained"
						className={classes.createButton}
						disabled={isUpdating || isEditorEmpty(input)}
				>
						Add Note
					</ADD.ConfirmButton>
				</ADD.ButtonContainer>
			</ADD.ActionContainer>
			<DialogContent className={classes.dialogContent}>
					<div>
						<TextEditor
							placeholder="Note"
							value={input.note || ""}
							onChange={(content, delta, source, editor) => {
   						     setInput({ note: content, editor });
						   }}
							withColors={true}
						/>
					</div>
			</DialogContent>
		</Dialog>
	);
};

export default AddNoteDialog;
